/**
 * nailArt — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const nailArtPack: ToilePack = {
    slug: 'nail-art',
    category: 'nails',
    name: 'Nail art',
    tagline: tagline('sets', 'designs', 'nail shapes'),
    chips: chips('designs', 'shapes'),
    ratio: SQUARE,
    readings: [
        {key: 'french', label: 'French twist', subject: 'the smile line reshaped and doubled in a second color'},
        {key: 'autumn', label: 'Autumn set', subject: 'rust, olive and cocoa with pressed leaves and a gold line'},
        {key: 'chrome', label: 'Chrome metallic', subject: 'mirror chrome, silver-to-lilac, one accent nail'},
    ],
    styles: [
        {key: 'almond', label: 'Almond', style: 'almond shape, tapered to a soft point', palette: 'glossy topcoat', framing: 'five tips in a graded row, from above'},
        {key: 'square', label: 'Square', style: 'square shape, flat free edge, short', palette: 'glossy topcoat', framing: 'five tips in a graded row, from above'},
        {key: 'coffin', label: 'Coffin', style: 'coffin shape, tapered to a blunt tip, long', palette: 'glossy topcoat', framing: 'five tips in a graded row, from above'},
    ],
    directions: ['with tiny florals', 'in soft nude tones', 'one glittered accent nail'],
}
